import { createGlobalStyle } from 'styled-components';

// App-wide global styles (styled-components). Complements the vendor template
// CSS; primarily neutralises the template's jumpy smooth-scroll in the SPA.
export const GlobalStyle = createGlobalStyle`
  html {
    scroll-behavior: auto !important;
  }

  /* Reveal-animation elements must never stay hidden/offset if their GSAP
     ScrollTrigger doesn't (re)fire after a route change. */
  .tp_fade_anim,
  [data-fade-from],
  .tp_text_invert {
    opacity: 1 !important;
    visibility: visible !important;
  }
`;

export default GlobalStyle;
